import 'select2/dist/js/select2.js';
import 'select2/dist/js/i18n/es.js';
export const activateSelect2 = () => {

  $('.select2').click(function(e) {
    e.stopPropagation();
  });

  $('.select2').each(function() {
    $(this).select2({
      theme: 'bootstrap-5',
      dropdownParent: $(this).parent(),
      maximumSelectionLength: 3,
    });
  });

}
